import React from 'react';
import './Footer.css';
import logoIcon from './logo.svg';

const Footer = ({ onAboutClick }) => {
  return (
    <footer className="footer">
      {/* Main Footer (Dark Background) */}
      <div className="footer-main">
        <div className="footer-container">

          {/* LEFT COLUMN: Logo, Socials, Address */}
          <div className="footer-left">
            <div className="brand-social-group">
                {/* Logo */}
                <div className="footer-brand">
                    <img src={logoIcon} alt="" className="footer-logo-icon" />
                </div>

                {/* Social Icons */}
                <div className="footer-social">
                    <a href="https://www.linkedin.com/in/zhengtao-frank-hu" target="_blank" rel="noopener noreferrer" className="social-link">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                    </a>
                    <a href="https://www.youtube.com/@AtomicArch-r3d" target="_blank" rel="noopener noreferrer" className="social-link">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/></svg>
                    </a>
                </div>
            </div>

            {/* Address Block */}
            <div className="footer-address">
                <p>8 The Green STE D, Dover, County of Kent, Delaware, 19901</p>
            </div>
          </div>

          {/* RIGHT COLUMN: Navigation & Legal */}
          <div className="footer-right">
            {/* Top Row: Links Columns */}
            <div className="footer-links-row">
                <div className="link-column">
                    <h4>Product</h4>
                    <a href="#features">Features</a>
                </div>
                <div className="link-column">
                    <h4>Company</h4>
                    <a href="#top" onClick={onAboutClick}>About</a>
                    <a href="#contact">Contact</a>
                </div>
            </div>

            {/* Bottom Row: Legal & Copyright */}
            <div className="footer-legal-row">
                <div className="copyright-text">
                    <p>InstantUrban Co. Cooperation</p>
                </div>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
